export default __webpack_public_path__ + "static/media/operator-desktop.43f1978f.svg";